import styled from "styled-components"
import media from "../../styles/media"

export const RuleLine = styled.div`
  color: ${props => props.theme.black};
  grid-column: 1 / span 4;
  margin-top: 25px;
  border-top: 1px solid ${props => props.theme.black};
  margin-bottom: -15px;
  min-width: 0;
  padding-top: 0;
  padding-bottom: 0;

  ${media.tablet`
    grid-column: 1 / span 12;
    margin-right: 20px;
`}
`
